import {SchoolWithAccessLevel} from "../../models/School";
import Actions from "../Actions";

const schoolsReducer = (state: { schoolsCanAccess?: SchoolWithAccessLevel[] } | undefined, action: { type: string, schoolsCanAccess?: SchoolWithAccessLevel[], userIsTenantManager: boolean, school?: string, tenantId: string, schoolCode: string}) => {
    
    if(state === undefined)
    {
        return {
            schoolsCanAccess: undefined,
            userIsTenantManager: false,
        };
    }
    
    switch (action.type)
    {
        case Actions.SET_SCHOOLS_CAN_ACCESS:
            return Object.assign({},state,{schoolsCanAccess: action.schoolsCanAccess,userIsTenantManager: action.userIsTenantManager});
            
        default:
            return state;
    }
};

export default schoolsReducer;
